// "Lo de siempre" en su propia pantalla (el acceso de la barra de arriba en computadora): lo que más pide el negocio,
// en grilla, y su último pedido para repetirlo.
import { Icono } from '@reparto/ui';
import { Link } from 'react-router';
import { Pantalla } from '../componentes/Marco';
import { useNegocio } from '../datos/cuenta';
import { useReglas } from '../datos/fuente';
import { LoDeSiempre } from './Inicio';

export function Habituales() {
  const negocio = useNegocio()!;
  const reglas = useReglas();
  return (
    <Pantalla titulo="Lo de siempre" subtitulo={negocio.nombre} volver="/" amplia>
      <div className="px-4 pb-8">
        <LoDeSiempre negocioId={negocio.id} permitirSinStock={reglas.permitirSinStock} grilla />
        <Link
          to="/buscar"
          className="mt-6 flex min-h-12 items-center justify-center gap-1 text-[15px] font-semibold text-primary-700 hover:underline"
        >
          ¿Buscás otra cosa? Ver todo el catálogo
          <Icono nombre="chevron_right" tamano={20} />
        </Link>
      </div>
    </Pantalla>
  );
}
